import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-types-papi';
import { MyBadges, Props as WidgetProps } from './MyBadges';
import reduxConnectContainer from './MyBadges.container';
import EmptyState from '../../EmptyState';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';
import getStatLine from '../../../utils/getStatLine';
import { URLS } from '@wix/da-url';

import s from './MyBadges.scss';

const enhance = compose(
  reduxConnectContainer,
  withTranslation()
);

class MyBadgesInExpandedWidgetContainer extends React.Component<
  WidgetProps &
    WidgetBoxWideProps &
    WithTranslation & {
      currentUser: PapiUser;
      hasMoreBadgeActivity: boolean;
      fetchMoreBadgeActivity: () => void;
      isFetchingBadgeActivity: boolean;
      profileOwnerUser: PapiUser;
    }
> {
  render() {
    const {
      id,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      hasMoreBadgeActivity,
      fetchMoreBadgeActivity,
      isFetchingBadgeActivity,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      widgetBoxClassName,
      parentRef,
      isEmpty,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        section={section}
        zone={zone}
        moduleId={props.moduleId}
        id={id}
        header={props.t!('widgets.myBadges.header')}
        count={props.totalReceived}
        subHeader={getStatLine(props.t!, 'badges', props.totalReceived)}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        hasMore={hasMoreBadgeActivity}
        fetchMore={fetchMoreBadgeActivity}
        isFetching={isFetchingBadgeActivity}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
        parentRef={parentRef}
        isEmpty={isEmpty}
        emptyView={
          props.isCurrentUserProfileOwner ? (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!('widgets.myBadges.empty.title.owner')}
              subtitle={props.t!('widgets.myBadges.empty.subtitle.owner')}
              withButton
              buttonLabel={props.t!('widgets.myBadges.empty.CTALabel.owner')}
              onButtonClick={this.navigateToBrowse}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!('widgets.myBadges.empty.title.visitor', {
                username: props.profileOwnerUser.username,
              })}
              subtitle={props.t!('widgets.myBadges.empty.subtitle.visitor', {
                username: props.profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <MyBadges {...props} />
      </WidgetBoxWide>
    );
  }

  navigateToBrowse() {
    window.location.replace(URLS.ROOT);
  }

  // TODO uncomment when designed and implemented
  // openNewWindow = (closeMenu: () => void) => {
  //   window.open(
  //     Url.userLink(this.props.currentUser.username, '/badges'),
  //     '_blank'
  //   );
  //   return null;
  // };
}

export default enhance(
  MyBadgesInExpandedWidgetContainer
) as React.ComponentType<
  Pick<
    WidgetBoxWideProps,
    | 'moduleId'
    | 'id'
    | 'isHeaderStickyOnMobile'
    | 'subHeader'
    | 'headerExtraElementsOnMobile'
  >
>;
